import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import Header from './Header';
import { useI18n } from '../i18n/I18nContext';
import { EnglishLegalNotice } from '../i18n/EnglishLegal';
import './Impressum.css';

function Impressum() {
  const { lang } = useI18n();
  if (lang === 'en') return <EnglishLegalNotice />;

  return (
    <div className="michaela-impressum-section">
      <Seo page="impressum" />
      <Header />
      <div className="michaela-impressum-content">
        <Link to="/" className="michaela-impressum-back-link">
          ← Zurück zur Startseite
        </Link>
        <h1 className="michaela-impressum-title">Impressum</h1>
        
        <div className="michaela-impressum-text">
          <h2 className="michaela-impressum-subtitle">
            Angaben gemäß § 5 DDG und § 18 Abs. 2 MStV
          </h2>
          
          <div className="michaela-impressum-block">
            <p>Michaela Braun</p>
            <p>Rechtsanwältin</p>
            <p>zertifizierte Wirtschaftsmediatorin</p>
            <p>zertifizierte systemisch-integrative Businesscoachin</p>
            <p>zertifizierte PCM-Coachin</p>
            <p>Kirchenstraße 87 b</p>
            <p>81675 München</p>
          </div>

          <div className="michaela-impressum-block">
            <p>Telefon: +49 (0)171 8208818</p>
            <p>E-Mail: <a href="mailto:mb@michaelabraun.de">mb@michaelabraun.de</a></p>
            <p>Web: <a href="https://www.michaelabraun.de" target="_blank" rel="noopener noreferrer">www.michaelabraun.de</a></p>
          </div>

          <h3 className="michaela-impressum-heading">Zuständige Kammer:</h3>
          <div className="michaela-impressum-block">
            <p>Rechtsanwaltskammer München</p>
            <p>Tal 33, 80331 München</p>
            <p><a href="https://www.rak-muenchen.de" target="_blank" rel="noopener noreferrer">www.rak-muenchen.de</a></p>
          </div>

          <h3 className="michaela-impressum-heading">Berufsbezeichnung und berufsrechtliche Regelungen:</h3>
          <div className="michaela-impressum-block">
            <p>Berufsbezeichnung: Rechtsanwältin (verliehen in der Bundesrepublik Deutschland)</p>
            <p>Es gelten die folgenden berufsrechtlichen Regelungen:</p>
            <ul className="michaela-impressum-list">
              <li>Bundesrechtsanwaltsordnung (BRAO)</li>
              <li>Berufsordnung für Rechtsanwälte (BORA)</li>
              <li>Fachanwaltsordnung (FAO)</li>
              <li>Rechtsanwaltsvergütungsgesetz (RVG)</li>
              <li>Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE)</li>
            </ul>
            <p>Diese Regelungen sind abrufbar unter <a href="https://www.brak.de" target="_blank" rel="noopener noreferrer">www.brak.de</a>.</p>
          </div>

          <h3 className="michaela-impressum-heading">Umsatzsteuer-ID:</h3>
          <div className="michaela-impressum-block">
            <p>USt.-ID/VAT DE171124821</p>
          </div>

          <h3 className="michaela-impressum-heading">Berufshaftpflichtversicherung:</h3>
          <div className="michaela-impressum-block">
            <p>ERGO Versicherungs AG</p>
            <p>Victoriaplatz 1</p>
            <p>40477 Düsseldorf</p>
            <p>Räumlicher Geltungsbereich: EU-Gebiet und EWR-Staaten.</p>
          </div>

          <h3 className="michaela-impressum-heading">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</h3>
          <div className="michaela-impressum-block">
            <p>Michaela Braun, Kirchenstraße 87 b, 81675 München</p>
          </div>

          <h3 className="michaela-impressum-heading">Haftungsausschluss:</h3>
          <div className="michaela-impressum-block">
            <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine Haftung für Inhalte externer Links.</p>
            <p>Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
            <p>Die Inhalte dieser Website dienen ausschließlich der allgemeinen Information und stellen keine Rechtsberatung dar.</p>
          </div>

          <h3 className="michaela-impressum-heading">Abgrenzung anwaltlicher und nichtanwaltlicher Tätigkeit:</h3>
          <div className="michaela-impressum-block">
            <p>Die auf dieser Website angebotenen Coaching-, Mediations- und Trainingsdienstleistungen erfolgen außerhalb der anwaltlichen Tätigkeit und unterliegen nicht der Berufsaufsicht der Rechtsanwaltskammer. Sie ersetzen keine Rechtsberatung im Einzelfall.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Impressum;

